import { Link } from "react-router-dom";

import Logo from "@/components/Logo";

export default function AuthShell({
  title,
  subtitle,
  children,
  footer,
  icon,
}: {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  footer: React.ReactNode;
  icon?: React.ReactNode;
}) {
  return (
    <main className="relative min-h-screen px-6 py-8">
      {/* backdrop glow */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-24 -z-10 h-80 w-[40rem] max-w-full -translate-x-1/2 rounded-full blur-[150px]"
        style={{ background: "rgba(225,100,46,0.14)" }}
      />

      <Link
        to="/"
        className="absolute left-6 top-6 flex items-center gap-1.5 text-sm transition hover:text-primary"
        style={{ color: "var(--text-muted)" }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5M12 19l-7-7 7-7" />
        </svg>
        Back
      </Link>

      <div className="mx-auto flex min-h-[calc(100vh-4rem)] max-w-md flex-col items-center justify-center">
        <Link to="/" className="mb-7 font-display text-2xl font-bold tracking-tight transition hover:opacity-80">
          <Logo />
        </Link>

        <div
          className="w-full rounded-[16px] p-8"
          style={{
            background: "var(--bg-elev)",
            border: "1px solid var(--border)",
            boxShadow: "var(--shadow-card)",
          }}
        >
          {icon && (
            <div className="mb-4 flex justify-center text-primary">{icon}</div>
          )}
          <h1 className="text-center text-3xl font-bold font-display">{title}</h1>
          <p className="mt-1.5 text-center text-sm" style={{ color: "var(--text-muted)" }}>{subtitle}</p>

          <div className="mt-7">{children}</div>

          <p className="mt-5 text-center text-sm" style={{ color: "var(--text-muted)" }}>{footer}</p>
        </div>

        <p className="mt-6 text-center text-xs" style={{ color: "var(--text-muted)" }}>
          By continuing, you agree to our{" "}
          <Link to="/legal/terms" className="text-primary hover:underline">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link to="/legal/privacy" className="text-primary hover:underline">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
    </main>
  );
}

export const AUTH_BUTTON =
  "flex w-full items-center justify-center gap-1.5 rounded-[12px] bg-primary py-2.5 font-display font-semibold text-white shadow-btn transition-all duration-150 hover:bg-primary-hover hover:shadow-[0_0_28px_rgba(225,100,46,0.5)] active:scale-[0.98]";
